module.exports = __webpack_public_path__ + "img/btn_back.6c12cd06.png";